import React from 'react'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import styles from './SaveTemplate.module.scss'

export const SaveTemplate = () => (
  <div className={styles.save}>
    <MessageAlert
      className={styles.alert}
      message={t`You have successfully created new job.`}
      variant="success"
      isInitialised
    />
    <h3 className={styles.title}>
      <span>{t`Would you like to save this new job as a`}</span>
      <strong className={styles.bold}>{t`template`}</strong>?
    </h3>
    <p
      className={styles.text}
    >{t`If you are unsure, you will be able to edit it or save job as a template later too in the job main menu.`}</p>
  </div>
)
